export default __webpack_public_path__ + "static/media/swipe-sri-desktop.76e413ca.png";